import { RandomUtils } from '../utils/random-utils';

export enum GenericEngagementFormatEnum {
  QUOTE = 'Devis',
  CONTRACT = 'Contrat',
  INTERNE = 'Interne',
}

export const genericEngagementTranslation = (status: GenericEngagementFormatEnum) => {
  switch (status) {
    case GenericEngagementFormatEnum.CONTRACT.toString():
      return 'Contract';
    case GenericEngagementFormatEnum.QUOTE.toString():
      return 'Devis';
    case GenericEngagementFormatEnum.INTERNE.toString():
      return 'Interne';
    default:
      return null;
  }
};

export const genericEngagementTranslationObject = (status: GenericEngagementFormatEnum) => {
  return {
    _id: RandomUtils.generateId(),
    value: status,
    label: genericEngagementTranslation(status),
  };
};
